import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RatingModule } from 'primeng/rating';
import { TableModule } from 'primeng/table';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { HeadingComponent } from '../../../shared/components/heading/heading.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserClientVm } from '../../../store/user/user.interface';
import { UserService } from '../../services/user.service';
import { ReviewerService } from '../../services/reviewer.service';
import { HelperService } from '../../services/helper.service';
import { DocumentService } from '../../services/document-service';
import { ToastService } from '../../services/toast.service';
import { Credential, Criteria, ReviewerProfile, Tenant } from '../../../store/reviewer/reviewer.interface';
import { constants, UserRoles } from '../../constants/constants';
import { CommonModule } from '@angular/common';
import { Document } from '../../../modules/reviewer/profile/profile.interface';
import { AddToTalentPoolListComponent } from '../add-to-talent-pool-list/add-to-talent-pool-list.component'
import { TooltipModule } from 'primeng/tooltip';
import { PeopleService } from '../../services/people.service';
import { ConfirmationDialogService } from '../../services/confirmation-dialog.service';
import { UpdateUserStatus } from '../../../modules/client/dashboard/people/people.interface';
import { InputSwitchModule } from 'primeng/inputswitch';
import { UpdateUserDataComponent } from '../update-user-data/update-user-data.component';
import { RemovedSkillsCredentialsComponent } from '../removed-skills-credentials/removed-skills-credentials.component';
import { ConfigurationService } from '../../services/configuration.service';
import { FirmService } from '../../services/firm.service';
import { AddSkillsComponent } from '../add-skills/add-skills.component';
import { PipesModule } from '../../pipes/pipes.module';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SkeletonModule } from 'primeng/skeleton';
import { AllowUserProfileFieldComponent } from '../allow-user-profile-field/allow-user-profile-field.component';
import { AddCredentialsComponent } from '../../../modules/reviewer/profile/credentials/add-credentials/add-credentials.component';
import { TagModule } from 'primeng/tag';
@Component({
  selector: 'app-reviewer-profile',
  standalone: true,
  imports: [SkeletonModule, AvatarModule, RatingModule, TableModule, FormsModule, ButtonModule, InputTextareaModule, CommonModule, AddToTalentPoolListComponent, TooltipModule, InputSwitchModule, TagModule, PipesModule],
  templateUrl: './reviewer-profile.component.html',
  styleUrl: './reviewer-profile.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ReviewerProfileComponent implements OnInit {
  currentUser!: UserClientVm;
  showMore: boolean = false;
  maxLength: number = 200;
  headingButton = {
    url: '/client/project/create',
    label: 'INVITE CANDIDATE'
  }
  newNote: string = '';
  user!: ReviewerProfile;
  pastProjects: any[] = [];
  pastProjectsLoaded: boolean = false;
  currentProjects: any[] = []; 
  currentProjectsLoaded: boolean = false;
  docuSignDocuments: any[] = [];
  docuSignDocumentsLoaded: boolean = false;
  firmReviewerDocuments: any[] = [];
  notes: any[] = [];
  talentPoolAssigned: any[] = [];
  talentPoolsLoaded: boolean = false;
  showTalentPoolListing: boolean = false;
  showEditSkillExperience: boolean = false;
  showEditCredentials: boolean = false;
  reviewerInactiveCriteria: Criteria[] = [];
  reviewerInactiveCredentials: Credential[] = [];
  secureBackgroundStatus = constants.secureBackgroundStatus;
  isAdminApprovalPending = false;
  positions: any = [];
  isPwcEnabled = false;
  currentTenant: any = null;
  userProfileEditTypes: any = constants.userProfileEditTypes;
  positionStatus: any = constants.positionStatus;
  firm: any = null;

  constructor(private reviewerDetailRef: DynamicDialogRef, public config: DynamicDialogConfig, private userService: UserService,
    private dialogService: DialogService,
    private reviewerService: ReviewerService, public helperService: HelperService, private documentService: DocumentService,
    private toast: ToastService, private peopleService: PeopleService, private confirmationDialogService: ConfirmationDialogService,
    private configurationService: ConfigurationService, private firmService: FirmService
  ) { }

  // ngOnInit now calls initialize
  ngOnInit() {   
    this.initialize();
  }

  // Synchronous data fetching in order
  async initialize() {
    this.isPwcEnabled = this.configurationService.getPwcFlag();
    this.currentUser = this.userService.getSessionUser();
    await this.getReviewerDetails();
    await this.getCurrentFirm();
    await this.getReviewerPastProjects();
    await this.getReviewerCurrentProjects();
    await this.getReviewerDocuSignDocuments();
    await this.getFirmReviewerDocuments();
    await this.getAllTalentPoolByReviewerId();
  }

  toggleShow() {
    this.showMore = !this.showMore;
  }

  async getCurrentFirm() {
    this.firm = await lastValueFrom(
      this.firmService.getFirm(this.currentUser.firm._id)
    );
  }

  async getAllTalentPoolByReviewerId() {
    const resp = await lastValueFrom(
      this.reviewerService.getAllTalentPoolByReviewerId(this.config.data.reviewerId)
    );
    this.talentPoolAssigned = resp;
    this.talentPoolsLoaded = true;
  }

  async rateUser(){
    const payload = {
      userId: this.user._id,
      ratings: this.currentTenant.defaultRatings
    };

    await this.firmService.updateUserRatingByFirm(payload);
  }

  async getFirmReviewerDocuments() {
    const params = {
      reviewerId: this.config.data.reviewerId,
      firmId: this.currentUser.firm._id
    };
    const resp = await lastValueFrom(this.reviewerService.getFirmReviewerDocuments(params));
    resp.map((d: any) => {
      d.url = this.documentService.getDocumentPathById(d._id);
    });
    this.firmReviewerDocuments = resp;
  }

  async getReviewerDocuSignDocuments() {
    const resp = await lastValueFrom(
      this.reviewerService.getReviewerDocuSignDocuments(this.config.data.reviewerId, this.currentUser.firm._id)
    );
    this.docuSignDocuments = resp.filter((d: any) => d.firm === this.currentUser.firm._id);
    this.docuSignDocumentsLoaded = true;
  }

  favouriteUser() {
    if(this.user.isFavorite){
      this.removeAsFavourite();
    }else{
      this.setAsFavourite();
    }
  }

  removeAsFavourite() {
    this.peopleService.removeFromFavouriteList(this.currentUser.firm._id, this.user._id).subscribe({
      next: () => {
        this.user.isFavorite = false
      }
    });
  }

  setAsFavourite() {
    const fav = {
      favorite: this.user._id
    };
    this.peopleService.addToFavouriteList(this.currentUser.firm._id, fav).subscribe({
      next: () => {
        this.user.isFavorite = true;
      },
    });
  }

  async getReviewerPastProjects() {
    const resp = await lastValueFrom(
      this.reviewerService.getReviewerFirmPastProjects(this.config.data.reviewerId, this.currentUser.firm.id)
    );
    this.pastProjects = resp;
    this.pastProjectsLoaded = true;
  }

  async getReviewerCurrentProjects() {
    const resp = await lastValueFrom(
      this.reviewerService.getReviewerFirmCurrentProjects(this.config.data.reviewerId, this.currentUser.firm.id)
    );
    this.currentProjects = resp;
    this.currentProjectsLoaded = true;
  }

  async getReviewerDetails() {
    const resp: ReviewerProfile = await lastValueFrom(
      this.reviewerService.getReviewerProfile(this.config.data.reviewerId, this.currentUser.firm._id)
    );
    this.user = resp;
    this.user.profile.contact.home = this.helperService.formatPhoneNo(this.user.profile.contact.home);
    this.currentTenant = this.user.tenants.find((tenant: any) => tenant.firm === this.currentUser.firm._id) as Tenant;
    this.isAdminApprovalPending = this.currentTenant.reviewerStatus === constants.userVerificationStatus.pendingAdminVerification;
    this.reviewerInactiveCriteria = this.user.profile.criterias.filter((criteria) => criteria.status === 'Inactive');
    this.user.profile.criterias = this.user.profile.criterias.filter((criteria) => criteria.status === 'Active');
    this.reviewerInactiveCredentials = this.user.profile.credentials.filter((credential) => credential.status === 'Inactive');
    this.user.profile.credentials = this.user.profile.credentials.filter((credential) => credential.status === 'Active');
    this.user.profile.jobCategories = this.user.profile.jobCategories.filter((job) => job?.isDeleted === false);

    this.user.profile.criterias.forEach((criteria) => {
      criteria.criteriaSelectedOptions = criteria.criteriaSelectedOption
        .map((option) => {
          let result = option.val;
          if (option.isExperienceEnabled && option.selectedExperienceLevel?.experience) {
            result += `: ${option.selectedExperienceLevel.experience}`;
          }
          return result;
        })
        .join(', ');
    });
    this.user.status = this.currentTenant.isActive;
    this.user.isFavorite = this.user.favorite && this.user.favorite.favorites && this.user.favorite.favorites.length ? this.user.favorite.favorites.indexOf(this.user._id) > -1 : false;
    this.user.documents.forEach((d: any) => {
      if (d.documentType !== constants.documentTypes.resume)
        d.url = this.documentService.getDocumentPathById(d._id);
    });
  }

  hasAnySelectedCriteria(): boolean{
    return !!(this?.user?.profile?.criterias?.some(criteria => criteria.criteriaSelectedOptions) || false);
  }

  status(data: any): string {
    if (data.secureBackgroundResult === this.secureBackgroundStatus.meetsRequirement) {
      return 'Verified';
    } else if (data.secureBackgroundStatus === this.secureBackgroundStatus.pending || data.secureBackgroundResult === this.secureBackgroundStatus.needsFurtherReview) {
      return 'Verification in progress';
    } else if (data.secureBackgroundResult === this.secureBackgroundStatus.doesntMeetsRequirement) {
      return 'Not verified';
    }
    return data.secureBackgroundResult;
  }

  onStatusToggleSwitch($event: Event, reviewer: any) {
    const currentTenant = reviewer.tenants.find((tenant: any) => tenant.firm === this.currentUser.firm._id);
    const mesg =  reviewer.currentlyAssignedOnPosition? 
    `${reviewer.firstName} ${reviewer.lastName} is currently on ${currentTenant?.positions[0]?.project?.codeName}. You can not deactivate them until they have been off boarded from their role.` :
    `Are you sure you want to ${reviewer.status ? 'activate' : 'deactivate'} ${reviewer.firstName} ${reviewer.lastName}. ${reviewer.status ? '' : 'Deactivated candidates are not eligible to receive offers until reactivated'}`;
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message: mesg,
      header:  reviewer.currentlyAssignedOnPosition ? `${reviewer.firstName} ${reviewer.lastName} currently working` : 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: "none",
      rejectIcon: "none",
      rejectButtonStyleClass: "p-button-text",
      rejectVisible: reviewer.currentlyAssignedOnPosition ? false : true,
      acceptLabel: reviewer.currentlyAssignedOnPosition ? 'OK' : "YES",
      accept: () => {
        if (reviewer.currentlyAssignedOnPosition){
          reviewer.status = true;
        }else {
          const data: UpdateUserStatus = {
            userId: reviewer._id,
            status: reviewer.status
          }
          this.peopleService.updateUserStatusByFirm(data).subscribe({
            next: (resp) => {
              this.toast.showSuccess('User Update Successfully');
            },
            error: (error) => {
              reviewer.status = !reviewer.status;
            }
          });
        }
      },
      reject: () => {
        reviewer.status = !reviewer.status;
      }
    });
  }

  getDocumentPathById(docId: string){
    window.open(this.documentService.getDocumentPathById(docId) || '', '_blank');
  }

  openDocuSignDocument(envelopId: string, documentId: string, documentName: string) {
    this.reviewerService.viewEnvelopeDocument(envelopId, documentId).subscribe((res: any) => {
      let uri = "data:application/octet-stream," + window.escape(res);
      let downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = documentName + ".pdf";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  }

  addNote() {
    const note = this.newNote;
    this.reviewerService.addNote( this.config.data.reviewerId, note).subscribe((resp: any) => {
      this.newNote = '';
      this.user.notes.push(resp);
    })
  }

  onUploadDocument(event: any, type: string): void {
    const file = event.target.files[0];
    const opts = {
      documentType: type,
      firmId: this.currentUser.firm._id,
      reviewerId: this.config.data.reviewerId
    };
    this.uploadDocument(file, opts);
  }

  uploadDocument(file: any, opts: any) {

    this.documentService.uploadDocument(file, opts).subscribe((d: any) => {
      this.toast.showSuccess('Document uploaded successfully');
      this.getFirmReviewerDocuments();
    })
  }

  editDocument(event: any, type: string, data: Document) {
    const addDocument = { file: event.target.files[0], opts: {} };
    addDocument.opts = {
      documentType: type,
      firmId: this.currentUser.firm._id,
      reviewerId: this.config.data.reviewerId
    };
    this.deleteDocment(data._id, true, addDocument)
  }

  deleteDocment(id: string, edit?: boolean, data?: any) {
    this.documentService.deleteDocument(id).subscribe((d: any) => {
      if (edit) {
        this.uploadDocument(data.file, data.opts);
      } else {
        this.toast.showSuccess('Document deleted successfully');
        this.getFirmReviewerDocuments();
      }
    })
  }

  showTalentPool() {
    this.showTalentPoolListing = !this.showTalentPoolListing
  }

  currentUserisFMOrPM(){
    return this.currentUser.role === UserRoles.firmManager || this.currentUser.role === UserRoles.projectManager || this.currentUser.role === UserRoles.projectOwner; 
  }

  currentReviewerDidNotCompletedFirstStep(){
    return this.currentTenant.reviewerStatus === constants.userVerificationStatus.incomplete && !this.user.profile.contact.isPhoneVerified && this.user.profile.educations.length == 0;
  }

  getMappedData(data: any){
    return data.map((res: any) => {return {name: res.name, id: res._id}});
  }

  allowFieldOptions(){
    this.reviewerDetailRef = this.dialogService.open(AllowUserProfileFieldComponent, {
      header: `Add values for ${this.user.firstName} ${this.user.lastName}`,
      width: '22vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });

    this.reviewerDetailRef.onClose.subscribe((data: any) => {
      if (data) {
        this.editUserDetails(this.userProfileEditTypes.secondaryPayRate);
      }
    });
  }

  editUserDetails(type: string){
    let items;
    switch (type) {
      case this.userProfileEditTypes.email:
        items = [this.user.email];
        break;
      case this.userProfileEditTypes.searchMarket:
        items = this.getMappedData(this.user.profile.searchMarkets);
        break;
      case this.userProfileEditTypes.jobType:
        items = this.getMappedData(this.user.profile.jobCategories);
        break;
      case this.userProfileEditTypes.pwcEmail:
        items = [this.user.pwcEmail];
        break;
      case this.userProfileEditTypes.primaryPayRate:
        items = [this.user.profile.primaryPayRate];
        break;
      case this.userProfileEditTypes.secondaryPayRate:
        items = [this.user.profile.secondaryPayRate];
        break;
      case this.userProfileEditTypes.ranking:
        items = [{id: this.user.profile.ranking, name: this.user.profile.ranking}];
        break;
      case this.userProfileEditTypes.guid:
        items = [this.user.profile.guid];
        break;
      case this.userProfileEditTypes.contractorNumber:
        items = [this.user.profile.contractorNumber];
        break;
      case this.userProfileEditTypes.secondaryContractorNumber:
        items = [this.user.profile.secondaryContractorNumber];
        break;
      default:
        break;
    }

    this.reviewerDetailRef = this.dialogService.open(UpdateUserDataComponent, {
      data: {
        type: type,
        firmId: this.currentUser.firm._id,
        userId: this.user._id,
        userName: `${this.user.firstName} ${this.user.lastName}`,
        selectedItems: items
      },
      header: `Edit ${type} for ${this.user.firstName} ${this.user.lastName}`,
      width: [this.userProfileEditTypes.primaryPayRate, this.userProfileEditTypes.secondaryPayRate].includes(type) ? '22vw' : '30vw',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });

    this.reviewerDetailRef.onClose.subscribe((data: any) => {
      if (data) {
        this.toast.showSuccess(`${this.helperService.capitalizeFirstLetter(type)} updated successfully`);
        this.getReviewerDetails();
      }
    });
  }

  showSkillExperienceEdit(){
    this.showEditSkillExperience = !this.showEditSkillExperience;
  }

  editSkillExperience(id: string){
    this.deactivateSkills(id);
    let index = this.user.profile.criterias.findIndex((res) => res._id == id);
    this.user.profile.criterias.splice(index, 1);
  }

  showCredentialsEdit(){
    this.showEditCredentials = !this.showEditCredentials;
  }

  editCredentials(id: string){
    this.deactivateCredential(id);
    // MP-5739: the row passes the record _id (unique since MP-5737), so the
    // local list drops exactly that record (this previously compared the
    // certificate to the id and relied on the refetch to self-correct)
    let index = this.user.profile.credentials.findIndex((res) => res._id == id);
    if (index !== -1) {
      this.user.profile.credentials.splice(index, 1);
    }
  }

  showRemovedSkills(){
    if(this.reviewerInactiveCriteria.length){
      this.reviewerDetailRef = this.dialogService.open(RemovedSkillsCredentialsComponent, {
        data: {
          firmId: this.currentUser.firm._id,
          userId: this.user._id,
          data: this.reviewerInactiveCriteria,
          type: 'Skills',
          userName: `${this.user.firstName} ${this.user.lastName}`
        },
        header: `Removed Skills of ${this.user.firstName} ${this.user.lastName}`,
        width: '30vw',
        contentStyle: { overflow: 'auto' },
        breakpoints: {
          '960px': '75vw',
          '640px': '90vw'
        }
      });
  
      this.reviewerDetailRef.onClose.subscribe((data: any) => {
        if (data) {
          this.toast.showSuccess('Skills Activated Successfully');
          this.getReviewerDetails();
        }
      });
    }
    else {
      this.toast.showSuccess('No Removed Skills Found');
    }
  }

  showRemovedCredentials(){
    if(this.reviewerInactiveCredentials.length){
      this.reviewerDetailRef = this.dialogService.open(RemovedSkillsCredentialsComponent, {
        data: {
          firmId: this.currentUser.firm._id,
          userId: this.user._id,
          data: this.reviewerInactiveCredentials,
          type: 'Credentials',
          userName: `${this.user.firstName} ${this.user.lastName}`
        },
        header: `Removed Credentials of ${this.user.firstName} ${this.user.lastName}`,
        width: '30vw',
        contentStyle: { overflow: 'auto' },
        breakpoints: {
          '960px': '75vw',
          '640px': '90vw'
        }
      });
  
      this.reviewerDetailRef.onClose.subscribe((data: any) => {
        if (data) {
          this.toast.showSuccess('Credentials Activated Successfully');
          this.getReviewerDetails();
        }
      });
    }
    else {
      this.toast.showSuccess('No Removed Credentials Found');
    }
  }

  addNewCredential(){
    this.reviewerDetailRef = this.dialogService.open(AddCredentialsComponent, {
      data: {
        firmId: this.currentUser.firm._id,
        userId: this.user._id,
        userName: `${this.user.firstName} ${this.user.lastName}`
      },
      header: `Add new credentials for ${this.user.firstName} ${this.user.lastName}`,
      width: '50vw',
      height: '50vh',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });

    this.reviewerDetailRef.onClose.subscribe((data: any) => {
      if (data) {
        this.getReviewerDetails();
      }
    });
  }

  /**
   * MP-5727: opens the add-credential form in edit mode for one record so an
   * FM can change its secondary value, membership number, expiration or
   * Active switch. The record _id is unique since MP-5737.
   */
  editCredential(cred: Credential){
    this.reviewerDetailRef = this.dialogService.open(AddCredentialsComponent, {
      data: {
        firmId: this.currentUser.firm._id,
        userId: this.user._id,
        userName: `${this.user.firstName} ${this.user.lastName}`,
        editId: cred._id
      },
      header: `Edit ${cred.name} for ${this.user.firstName} ${this.user.lastName}`,
      width: '50vw',
      height: '50vh',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });

    this.reviewerDetailRef.onClose.subscribe((data: any) => {
      if (data) {
        this.getReviewerDetails();
      }
    });
  }

  addNewSkills(){
    this.reviewerDetailRef = this.dialogService.open(AddSkillsComponent, {
      data: {
        firmId: this.currentUser.firm._id,
        userId: this.user._id,
        userName: `${this.user.firstName} ${this.user.lastName}`
      },
      header: `Add new skills & experience for ${this.user.firstName} ${this.user.lastName}`,
      width: '50vw',
      height: '55vh',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      }
    });

    this.reviewerDetailRef.onClose.subscribe((data: any) => {
      if (data) {
        this.toast.showSuccess('Skills & Experience updated Successfully');
        this.getReviewerDetails();
      }
    });
  }

  deactivateSkills(id: string){
    let body = {
      userId: this.user._id,
      idToUpdate: id
    };
    this.reviewerService.deactivateTenantCriteria(this.currentUser.firm._id, body).subscribe((res) => {
      this.toast.showSuccess('Skill Deactivated Successfully');
      this.getReviewerDetails();
    });
  }

  deactivateCredential(id: string){
    let body = {
      userId: this.user._id,
      idToUpdate: id
    };
    this.reviewerService.deactivateTenantCredential(this.currentUser.firm._id, body).subscribe((res) => {
      this.toast.showSuccess('Credential Deactivated Successfully');
      this.getReviewerDetails();
    });
  }
}
